import { render, staticRenderFns } from "./passwordLost.vue?vue&type=template&id=257de2b0&scoped=true&"
import script from "./passwordLost.vue?vue&type=script&lang=js&"
export * from "./passwordLost.vue?vue&type=script&lang=js&"
import style0 from "./passwordLost.vue?vue&type=style&index=0&id=257de2b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257de2b0",
  null
  
)

/* custom blocks */
import block0 from "./passwordLost.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "passwordLost.vue"
export default component.exports